import { createStore, createLogger } from 'vuex';
import { getModule } from 'vuex-module-decorators';
import licenses from './licenses';
import companies from './companies';
import feigcompanies from './feigCompanies';
import user from './user';
import usermanagement from './usermanagement';
import legaltext from './legaltexts';
import registertan from './registertan';
import envconfig from './envconfig';
import apppermission from './apppermissions';
import app from './app';
import { approles } from './approles';

const debug = process.env.NODE_ENV !== 'production';

export type Namespaces =
  | 'envconfig'
  | 'licenses'
  | 'companies'
  | 'feigcompanies'
  | 'user'
  | 'usermanagement'
  | 'legaltext'
  | 'registertan'
  | 'apppermission'
  | 'app';

const store = createStore({
  modules: {
    envconfig,
    licenses,
    companies,
    feigcompanies,
    user,
    usermanagement,
    legaltext,
    registertan,
    apppermission,
    app,
    approles,
  },
  strict: debug,
  plugins: debug ? [createLogger()] : [],
});

getModule(envconfig, store);
getModule(licenses, store);
getModule(companies, store);
getModule(feigcompanies, store);
getModule(user, store);
getModule(usermanagement, store);
getModule(legaltext, store);
getModule(registertan, store);
getModule(apppermission, store);
getModule(app, store);

export default store;
